import { PagingRequest } from "../common/paging";
import { DateRangeDto } from "../common/date.range";

export class CompetitorDto {
    id: number;
    name: string;
    tracked: boolean;
}

export class AwardDto {
    publicationDate: string;
    lastViewed: string;
    officialTitle: string;
    noticeId: number;
    buyerName: string;
    value: string;
    awardedCompanyName: string;
    jsPublicationDate: string;
    jsLastViewed: string;
}

export class CompetitorSearchModel extends PagingRequest {
    name: string;
}

export class CurrentCompetitorsSearchModel extends PagingRequest {
    name: string;
}

export class CompetitorAwardsSearchModel extends PagingRequest {
    name: string;
    publishedDateFrom: string;
    publishedDateTo: string;
}

export class CompetitorModalSearchModel extends PagingRequest {
    name: string;
}

export class CompetitorAwardSearchStorage {
    awardedCompanyName: string;
    publishedDate: DateRangeDto;
    pageNumber: number;

    constructor(request: CompetitorAwardsSearchModel) {
        this.awardedCompanyName = request.name;
        this.pageNumber = request.pageNumber;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/competitors/competitor.models.ts